import React from 'react'
import { Route, Routes } from 'react-router-dom'
import SignUp from '../pages/SignUp'
import { SignIn } from '../pages/SignIn'
import { Youtube } from '../pages/Youtube'
import { Video } from 'pages/product-video-editor'
import { Terms } from '../pages/Terms'
import { MyPayments } from '../pages/MyPayments'

import { QnA } from '../pages/QnA'
import { PaymentFail } from '../pages/payment/components/PaymentFail'
import { MyCashDashboard } from 'pages/MyCashDashboard'
import { ContentVideo } from 'pages/content-video-editor'
import { MyPage } from '../pages/MyPage'
import { CouponPack } from '../pages/CouponPack'
import { Challenge } from 'pages/Challenge'
import { CancelSubscription } from '../pages/CancelSubscription'
import { ShortFormPriceGuide } from '../pages/price-guide/ShortFormPriceGuide'
import { Subscription } from '../pages/Subscription'

import { CancelSubscriptionConfirm } from '../pages/CancelSubscriptionConfirm'
import Home from 'pages/Home'
import { GlobalPage } from 'pages/global'
import { PriceGuide } from 'pages/price-guide/PriceGuide'
import { VideoUsageHistory } from 'pages/video-usage-history'
import { PaymentSuccess } from 'pages/payment/components/PaymentSuccess'
import { Tiktok } from 'pages/tiktok'
import { TiktokSuccess } from 'pages/tiktok/success'

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/video-editor" element={<Video />} />
      <Route path="/short-video-editor" element={<ContentVideo />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/my-payments" element={<MyPayments />} />
      <Route path="/youtube-auth" element={<Youtube />} />
      <Route path="/cancel-subscription" element={<CancelSubscription />} />
      <Route
        path="/cancel-subscription-confirm"
        element={<CancelSubscriptionConfirm />}
      />
      <Route path="/QnA" element={<QnA />} />
      <Route path="/global" element={<GlobalPage />} />
      <Route path="/my-page" element={<MyPage />} />
      <Route path="/my-videos" element={<VideoUsageHistory />} />
      <Route path="/payment-fail" element={<PaymentFail />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/price-guide" element={<PriceGuide />} />
      <Route path="/shortform-price-guide" element={<ShortFormPriceGuide />} />
      <Route path="/my-cash-dashboard" element={<MyCashDashboard />} />
      <Route path="/coupon-pack" element={<CouponPack />} />
      <Route path="/challenge" element={<Challenge />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/tiktok" element={<Tiktok />} />
      <Route path="/success" element={<TiktokSuccess />} />
      <Route path="/*" element={<Home />} />
    </Routes>
  )
}
